import styles from "./NoDataDp.module.scss";
import NoDataReportsImg from "../../../assets/images/reportNoData.svg";
import classNames from "classnames";

type Props = {
  title?: React.ReactNode;
  subTitle?: React.ReactNode;
  button?: boolean;
  buttonText?: string;
  image?: string;
  onClick?: (e: React.SyntheticEvent) => void;
};

const NoDataDpContainer = ({
  title = null,
  subTitle = null,
  button = false,
  buttonText = "",
  image = NoDataReportsImg,
  onClick = (e) => {},
}: Props) => {
  return (
    <div className={styles.noDataContainer}>
      <div className={styles.noDataBox}>
        <div>
          <img src={image} alt="" />
        </div>

        <div className={styles.textContainer}>
          <div className={styles.title}>
            {title ? title : "Roll in some reports"}
          </div>
          <div className={styles.subTitle}>
            {subTitle
              ? subTitle
              : "Pin reports from the workspaces to get rolling!"}
          </div>
          <div
            className={classNames(styles.btnContainer, !button && styles.hide)}
          >
            <button className={styles.proceedBtn} onClick={onClick}>
              {buttonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoDataDpContainer;
